import { Button } from '@mui/material';
import { styled } from '../muiReexports';
export const ButtonStyled = styled(Button)(({ size }) => ({
    '.MuiButton-endIcon': {
        marginLeft: '.625rem',
    },
    ...(size === 'small' ? { paddingRight: '1rem', paddingLeft: '1rem' } : {}),
}));
